import PropTypes from "prop-types";
import closeIcon from "../assets/closeIcon.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axios/axios";

const RejectionCard = ({ handleRejection, id, applicationId }) => {
  const navigate = useNavigate();

  const handleRejectApplication = async (id) => {
    try {
      const res = await axiosInstance.put(
        `RejectApplicationByOrg/${applicationId}`,
        {
          org_id: id, // Ensure this is sent as a JSON object
        }
      );

      navigate("/dashboard/applications");
      console.log(res);
      console.log("res");
    } catch (error) {
      console.log(error);
    }
    console.log("Application rejected");
  };
  return (
    <div className="min-h-screen h-full xsm:fixed flex w-full items-center justify-center absolute rejection-card flex-col">
      <div className="bg-white w-2/3 flex flex-col items-center justify-center p-3 rounded-3xl gap-2">
        <img
          src={closeIcon}
          alt=""
          className=" cursor-pointer"
          onClick={handleRejection}
        />
        <span className="reject-text">Rejection Card</span>
        <span className=" text-center text-sm text-[#475467]">
          Please confirm the decision to reject the candidate and send a formal
          rejection letter.
        </span>
        <section className="flex gap-3 my-3">
          <button className="btn  w-full text-white hover:bg-[#780202] bg-[#BC1518]">
            Cancel
          </button>
          <button
            onClick={() => handleRejectApplication(id)}
            className="btn  w-full  text-white hover:bg-[#1E4929] bg-[#049645]"
          >
            Confirm
          </button>
        </section>
      </div>
    </div>
  );
};

RejectionCard.propTypes = {
  handleRejection: PropTypes.func, // Add PropTypes validation
  id: PropTypes.string,
  applicationId: PropTypes.number,
};

export default RejectionCard;
